import { WidgetBreadcrumbProps } from '@/types/cms'
import BreadcrumbList from '@/elements/widgets/Breadcrumb/BreadcrumbList'
import styles from './BreadcrumbDefault.module.scss'
import { toKebabCase } from '@/utils/string'
import React from 'react'
import { Link } from '@/components/Link'
import Icon from '@/components/Icon/Icon'
import AppContext from '@/types/context'
import { clsx } from 'clsx'

const BreadcrumbDefault = ({ item, context }: { item: WidgetBreadcrumbProps; context: AppContext }) => {
  let seoData = item

  let breadcrumbs = item.model?.sectionPath ?? []

  if (breadcrumbs && breadcrumbs[1]?.name !== 'Sport') {
    breadcrumbs.splice(1, 0, {
      name: 'Sport',
      url: 'https://www.n-tv.de/sport/',
      sectionVisible: true,
    })
  }

  seoData = {
    ...seoData,
    model: {
      ...seoData.model,
      showBreadcrumb: seoData.model?.showBreadcrumb || true,
      sectionPath: breadcrumbs,
    },
  }

  const isHidden = !context.metadata?.model.article && (breadcrumbs?.length ?? 0) <= 2
  return (
    <>
      <BreadcrumbList item={seoData} />
      {!isHidden && item.model?.showBreadcrumb === true && (
        <nav className={styles.breadcrumb}>
          {breadcrumbs?.map((breadcrumb, index) => {
            const isLast = breadcrumbs.length === index + 1
            const key = toKebabCase(breadcrumb.name) + index
            return (
              <React.Fragment key={key}>
                {isLast && !item.model?.lastBCItem ? (
                  <h1 className={styles['last-breadcrumb-item']}>{breadcrumb.name}</h1>
                ) : (
                  <div className={styles['breadcrumb-item-wrapper']}>
                    <span className={styles['breadcrumb-item']}>
                      {breadcrumb.sectionVisible ? (
                        <Link href={breadcrumb.url}>{breadcrumb.name}</Link>
                      ) : (
                        breadcrumb.name
                      )}
                    </span>
                    <Icon name="chevronRight" size={16} className={styles.chevron} />
                  </div>
                )}
              </React.Fragment>
            )
          })}
          {item.model?.lastBCItem && <h1 className={styles['last-breadcrumb-item']}>{item.model?.lastBCItem.name}</h1>}
        </nav>
      )}
      {isHidden && <div className={clsx(styles.breadcrumb, styles.hidden)} />}
    </>
  )
}

export default BreadcrumbDefault
